import { render, staticRenderFns } from "./part-d.vue?vue&type=template&id=47a1c4f2&"
import script from "./part-d.vue?vue&type=script&lang=js&"
export * from "./part-d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports